module.exports = __webpack_public_path__ + "static/media/hackathon-logo.950b6898.png";